import script from "./ViewDelegationPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewDelegationPage.vue?vue&type=script&setup=true&lang=js"

import "./ViewDelegationPage.vue?vue&type=style&index=0&id=3007890d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3007890d"]])

export default __exports__